export default "__VITE_ASSET__DdLfIUQ4__"